/**
 * @fileoverview Job Contact Roles settings page
 *
 * URL: /dashboard/settings/contact-roles
 *
 * Manager for user-defined job-contact roles (name, colour, icon,
 * description). Any org member can create and edit them; they classify job
 * contacts more precisely than the built-in enum's broad "Other".
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { useActiveOrg } from "@/utils/org-context";
import { JobContactRolesManager } from "@/components/jobs/phases/contacts/JobContactRolesManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/settings/contact-roles",
)({
  component: ContactRolesPage,
  beforeLoad: () => ({
    title: "Contact Roles",
    headerTitle: "Settings",
  }),
});

function ContactRolesPage() {
  const { activeOrg, isLoading } = useActiveOrg();

  if (isLoading) {
    return (
      <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!activeOrg) {
    throw redirect({ to: "/dashboard" });
  }

  // Any org member can manage job-contact roles (mirrors the backend
  // `requireOrgMember` gate) — creating a role is a low-risk, collaborative
  // action, unlike the admin-curated firm directory categories.
  const canEdit = Boolean(activeOrg);

  return (
    <div className="flex h-full w-full flex-col bg-muted">
      <div className="mx-auto flex w-full max-w-screen-xl flex-1 flex-col p-6">
        <JobContactRolesManager orgId={activeOrg._id} canEdit={canEdit} />
      </div>
    </div>
  );
}
